var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoutWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.125 13.625C2.78125 13.625 2.48708 13.5027 2.2425 13.2581C1.99792 13.0135 1.87542 12.7192 1.875 12.375L1.875 3.625C1.875 3.28125 1.9975 2.98708 2.2425 2.7425C2.4875 2.49792 2.78167 2.37542 3.125 2.375L7.5 2.375V3.625L3.125 3.625L3.125 12.375L7.5 12.375V13.625L3.125 13.625ZM10 11.125L9.14062 10.2188L10.7344 8.625L5.625 8.625V7.375L10.7344 7.375L9.14062 5.78125L10 4.875L13.125 8L10 11.125Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutWhite);
export default __webpack_public_path__ + "static/media/logoutWhite.c7200c8ab188ea0a0df540f39af02566.svg";
export { ForwardRef as ReactComponent };